import { FC } from 'react';

import { Flex, Text } from '@mantine/core';

import IconCircleCheckInvert from '@/shared/uikit/assets/icons/IconCircleCheckInvert.svg?react';
import IconHeart from '@/shared/uikit/assets/icons/IconHeart.svg?react';

type NotificationProps = {
	text: string;
	type?: 'success' | 'warning' | 'error';
	action?: 'booking' | 'favorite';
	widget?: React.ReactNode;
};

export const Notification: FC<NotificationProps> = ({ text, type, action = 'booking', widget }) => {
	const icon = (action: NotificationProps['action']) => {
		switch (action) {
			case 'booking':
				return <IconCircleCheckInvert fontSize={22} />;

			case 'favorite':
				return <IconHeart color="#ffffff" fontSize={22} />;
		}
	};

	return (
		<Flex align="center" justify="center" gap={8}>
			{type !== 'error' && icon(action)}
			<Text c="white">{text}</Text>
			{widget}
		</Flex>
	);
};
